var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChitchatStep2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H62V62H4V8Z",
    fill: "#DDEEFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H58V58H2V6Z",
    fill: "#C7E2FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 54.33C4.64385 54.7718 7.3195 54.9959 10 55C34.85 55 55 36.42 55 13.5C54.9947 10.9815 54.7435 8.46963 54.25 6H2V54.33Z",
    fill: "#EBF7FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H58V18H2V6Z",
    fill: "#4472B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C12 2.89543 11.1046 2 10 2C8.89543 2 8 2.89543 8 4V8C8 9.10457 8.89543 10 10 10C11.1046 10 12 9.10457 12 8V4Z",
    fill: "#C1C8D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4C22 2.89543 21.1046 2 20 2C18.8954 2 18 2.89543 18 4V8C18 9.10457 18.8954 10 20 10C21.1046 10 22 9.10457 22 8V4Z",
    fill: "#C1C8D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 4C32 2.89543 31.1046 2 30 2C28.8954 2 28 2.89543 28 4V8C28 9.10457 28.8954 10 30 10C31.1046 10 32 9.10457 32 8V4Z",
    fill: "#C1C8D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42 4C42 2.89543 41.1046 2 40 2C38.8954 2 38 2.89543 38 4V8C38 9.10457 38.8954 10 40 10C41.1046 10 42 9.10457 42 8V4Z",
    fill: "#C1C8D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52 4C52 2.89543 51.1046 2 50 2C48.8954 2 48 2.89543 48 4V8C48 9.10457 48.8954 10 50 10C51.1046 10 52 9.10457 52 8V4Z",
    fill: "#C1C8D1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1801 27H41.0001V25H37.0001C36.7349 25 36.4806 25.1054 36.293 25.2929C36.1055 25.4804 36.0001 25.7348 36.0001 26V30H38.0001V27.76C40.4537 29.6762 42.1381 32.4093 42.7472 35.4623C43.3563 38.5153 42.8495 41.6855 41.319 44.3965C39.7886 47.1075 37.336 49.1793 34.4074 50.2351C31.4787 51.2909 28.2684 51.2607 25.3601 50.15L24.6401 52C26.3495 52.6622 28.167 53.0013 30.0001 53C33.0136 52.9964 35.9562 52.0852 38.4444 50.3851C40.9325 48.685 42.851 46.2749 43.9496 43.4688C45.0483 40.6628 45.2764 37.5908 44.604 34.6533C43.9316 31.7157 42.39 29.0488 40.1801 27Z",
    fill: "#88929F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22 48.24C19.5465 46.3238 17.862 43.5907 17.253 40.5377C16.6439 37.4847 17.1507 34.3145 18.6812 31.6035C20.2116 28.8925 22.6641 26.8207 25.5928 25.7649C28.5215 24.7091 31.7318 24.7393 34.64 25.85L35.36 24C33.6507 23.3378 31.8332 22.9987 30 23C26.9865 23.0036 24.044 23.9148 21.5558 25.6149C19.0676 27.315 17.1492 29.7251 16.0505 32.5312C14.9518 35.3373 14.7238 38.4092 15.3962 41.3468C16.0686 44.2843 17.6101 46.9512 19.82 49H19V51H23C23.2653 51 23.5196 50.8946 23.7072 50.7071C23.8947 50.5196 24 50.2652 24 50V46H22V48.24Z",
    fill: "#88929F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30 46C34.4183 46 38 42.4183 38 38C38 33.5817 34.4183 30 30 30C25.5817 30 22 33.5817 22 38C22 42.4183 25.5817 46 30 46Z",
    fill: "#F7D881"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30.07C30.3366 29.9767 29.6634 29.9767 29 30.07V33H31V30.07Z",
    fill: "#C1C8D1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45.93C29.6634 46.0233 30.3366 46.0233 31 45.93V43H29V45.93Z",
    fill: "#C1C8D1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38C22.0031 38.3344 22.0264 38.6684 22.07 39H25V37H22.07C22.0264 37.3316 22.0031 37.6656 22 38Z",
    fill: "#C1C8D1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35 39H37.93C38.0233 38.3366 38.0233 37.6634 37.93 37H35V39Z",
    fill: "#C1C8D1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.29 41.71L29.29 38.71C29.1973 38.6166 29.124 38.5057 29.0742 38.3839C29.0245 38.2621 28.9993 38.1316 29 38V35H31V37.59L33.71 40.29L32.29 41.71Z",
    fill: "#C1C8D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChitchatStep2Icon);
export default __webpack_public_path__ + "static/media/chitchat_step2_icon.db3155e97f0c6db04744973ee5f6ef89.svg";
export { ForwardRef as ReactComponent };